import { ClusterService } from '@fi-app/cluster/cluster.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { Transition } from '@uirouter/core';

export const FiClusterStateResolveCluster = [
    ClusterService,
    FiStateService,
    Transition,
    FiClusterStateResolveCluster_resolveFunc,
];

export function FiClusterStateResolveCluster_resolveFunc(
    clusterService: ClusterService,
    fiStateService: FiStateService,
    tr: Transition,
) {
    return clusterService.GetCluster(fiStateService.getParams(tr).Id);
}
